var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sui-dropdown',{ref:"dropdown",class:_vm.suiClass,attrs:{"options":_vm.options,"placeholder":_vm.placeholder,"multiple":_vm.multiple,"disabled":_vm.disabled,"direction":"downward","no-results-message":"Aucun résultat","search":""},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }